import { useQuery } from "@tanstack/react-query";

import { trpcClient } from "src/trpc";

function getKey() {
  return ["notifications"] as const;
}

export interface QueryOptions {}

export function useNotificationsQuery() {
  const query = useQuery({
    queryKey: getKey(),
    queryFn: async () => {
      return trpcClient.notifications.getAll.query();
    },
    refetchInterval: 10_000,
  });

  return query;
}
